export const trilingualModel = {
  title: "Progressive Trilingual Model",
  subtitle: "English immersion that grows with each stage",
  stages: {
    infantil: {
      title: "Early Years (3-6 years)",
      percentage: "40%",
      description: "Natural introduction to English in routines, games and daily activities"
    },
    cycle1: {
      title: "Primary Cycle 1 (6-9 years)",
      percentage: "45%",
      description: "Non-linguistic areas like Science and Arts in English, consolidating the communicative foundation"
    },
    cycle2: {
      title: "Primary Cycle 2 (9-12 years)",
      percentage: "50%",
      description: "Half of curriculum in English, with complete fluency in academic and social contexts"
    }
  },
  footer: "Spanish and Galician are present in all stages, ensuring mastery of all three languages"
};
